export default {
	title: "個人センター",
	subTitle: ["プロフィール", "セキュリティ", "システム"],
	menu: ["個人情報の変更", "ユーザー名", "パスワードの更新", "取引パスワードの更新"],
	updatePassword: {
		form: {
			label: ["古いパスワード", "新しいパスワード", "新しいパスワードの確認"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["古いパスワード", "新しいパスワード", "新しいパスワードの確認"]
		}
	}
};
